import React from 'react'

import { SignInContainer } from 'containers/Auth'

const SignIn = () => (
  <SignInContainer />
)

export default SignIn
